import React, { useState, useEffect } from "react";
import WelDataService from "../services/WelService";

const Wel = props => {
  const initialWelState = {
    amount: "",
    previousBalance: "",
    newBalance: ""
  };
  const [currentWel, setCurrentWel] = useState(initialWelState);
  const [message, setMessage] = useState("");

  const getWel = id => {
    WelDataService.get(id)
      .then(response => {
        setCurrentWel(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    getWel(props.match.params.id);
  }, [props.match.params.id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentWel({ ...currentWel, [name]: value });
  };

  const updateWel = () => {
    WelDataService.update(currentWel.id, currentWel)
      .then(response => {
        console.log(response.data);
        setMessage("Welfare transactions was updated successfully!");
      })
      .catch(e => {
        console.log(e);
      });
  };

  const deleteWel = () => {
    WelDataService.remove(currentWel.id)
      .then(response => {
        console.log(response.data);
        props.history.push("/wel");
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <div>
      {currentWel ? (
        <div className="edit-form">
          <h4>Welfare Transactions</h4>
          <form>
            <div className="form-group">
              <label htmlFor="amount">Amount</label>
              <input
                type="text"
                className="form-control"
                id="amount"
                name="amount"
                value={currentWel.amount}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="previousBalance">Previous Balance</label>
              <input
                type="text"
                className="form-control"
                id="previousBalance"
                name="previousBalance"
                value={currentWel.previousBalance}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="newBalance">New Balance</label>
              <input
                type="text"
                className="form-control"
                id="newBalance"
                name="newBalance"
                value={currentWel.newBalance}
                onChange={handleInputChange}
              />
            </div>
          </form>      

          <button className="badge badge-danger mr-2" onClick={deleteWel}>
            Delete
          </button>

          <button
            type="submit"
            className="badge badge-success"
            onClick={updateWel}
          >
            Update
          </button>
          <p>{message}</p>
        </div>
      ) : (
        <div>
          <br />
          <p>Please click on Welfare Transaction...</p>
        </div>
      )}
    </div>
  );
};

export default Wel;
